
const Assessors = ( ) => {
  
  
    return (
        <div id="assessors">
          <h1>This is the assessors section</h1>
           
    </div>
  )
}
 
export default Assessors;